import { render, staticRenderFns } from "./iscDetail.vue?vue&type=template&id=0c8ea036&scoped=true"
import script from "./iscDetail.vue?vue&type=script&lang=ts"
export * from "./iscDetail.vue?vue&type=script&lang=ts"
import style0 from "./iscDetail.vue?vue&type=style&index=0&id=0c8ea036&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8ea036",
  null
  
)

export default component.exports